import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-navigation-logged-out-home-section-products',
  template: `
    <app-navigation-logged-out-home-list
      [list]="productsList"
      [marginBottomTablet]="'xxsmall'"
    >
    </app-navigation-logged-out-home-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationLoggedOutHomeSectionProductsComponent {
  productsList = [
    {
      linkDescription: 'How it works',
      linkUrl: '/info/how-it-works',
    },
    {
      linkDescription: 'Contests',
      linkUrl: '/contest',
    },
    {
      linkDescription: 'Quotes',
      linkUrl: '/quotes',
    },
    {
      linkDescription: 'Photo Anywhere',
      linkUrl: 'https://www.photoanywhere.com',
    },
    {
      linkDescription: 'Showcase',
      linkUrl: '/showcase',
    },
  ];
}
